import React from 'react';
import { Shield, Heart, CheckCircle, Users } from 'lucide-react';

const CoreValues = ({ className = "" }) => {
  const coreValues = [
    {
      icon: Shield,
      title: "Respect & Dignity",
      description: "We honor the wisdom, experience, and individuality of every resident, ensuring they are treated with the utmost respect and dignity in all interactions.",
      color: "from-red-500 to-red-600",
      bgColor: "bg-red-50",
      textColor: "text-red-600"
    },
    {
      icon: Heart,
      title: "Compassionate Service",
      description: "Our team is dedicated to providing caring, empathetic service that goes beyond basic needs to create meaningful connections and emotional support.",
      color: "from-[var(--primarycolor)] to-[var(--primarycolor)]",
      bgColor: "bg-pink-50",
      textColor: "text-pink-600"
    },
    {
      icon: CheckCircle,
      title: "Integrity",
      description: "We maintain the highest standards of honesty, transparency, and ethical conduct in all our operations, building trust with families and residents.",
      color: "from-blue-500 to-indigo-600",
      bgColor: "bg-blue-50",
      textColor: "text-blue-600"
    },
    {
      icon: Users,
      title: "Community & Belonging",
      description: "We foster a sense of belonging and connection, creating vibrant communities where residents can form lasting friendships and feel truly at home.",
      color: "from-green-500 to-emerald-600",
      bgColor: "bg-green-50",
      textColor: "text-green-600"
    }
  ];

  return (
    <div className={`pt-20 sm:pt-28 px-6 md:px-12 ${className}`}>
      <div className="max-w-7xl mx-auto">
        {/* Section Header */}
        <div className="text-center mb-16">
          <div className="inline-flex items-center gap-2 bg-red-50 px-6 py-3 rounded-full text-[var(--primarycolor)] text-sm font-medium mb-8">
            <Shield className="w-4 h-4" />
            Our Foundation
          </div>
          
          <h2 className="text-4xl md:text-5xl font-light text-gray-900 mb-6 tracking-tight">
            Core Values That
            <span className="block text-[var(--primarycolor)] font-normal">Guide Everything We Do</span>
          </h2>
          
          {/* <p className="text-xl text-gray-600 max-w-3xl mx-auto font-light leading-relaxed">
            These fundamental principles shape our approach to senior living and drive our commitment to excellence in every aspect of care.
          </p> */}
        </div>

        {/* Values Grid */}
        <div className="grid md:grid-cols-2 gap-x-20 gap-y-16 mb-24">
          {coreValues.map((value, index) => {
            const IconComponent = value.icon;
            return (
              <div
                key={index}
                className="group"
              >
                {/* Icon */}
                <div className="mb-6">
                  <div className="inline-flex w-12 h-12 rounded-lg bg-[var(--primarycolor)] items-center justify-center group-hover:scale-105 transition-transform duration-200">
                    <IconComponent className="w-6 h-6 text-white" strokeWidth={1.5} />
                  </div>
                </div>
                
                {/* Content */}
                <div>
                  <h3 className="text-xl font-semibold text-gray-900 mb-3 tracking-tight">
                    {value.title}
                  </h3>
                  
                  <p className="text-gray-800 leading-relaxed font-light">
                    {value.description}
                  </p>
                </div>
              </div>
            );
          })}
        </div>

        {/* Values Summary */}
        <div className="text-center">
          <div className="max-w-4xl mx-auto bg-gradient-to-r from-gray-50 to-red-50/30 rounded-3xl p-12 relative overflow-hidden">
            {/* Background decoration */}
            <div className="absolute top-0 left-0 w-32 h-32 bg-red-500/5 rounded-full blur-2xl"></div>
            <div className="absolute bottom-0 right-0 w-40 h-40 bg-red-400/8 rounded-full blur-3xl"></div>
            
            <div className="relative z-10">
              <h3 className="text-2xl md:text-3xl font-light text-gray-900 mb-6">
                Values in Action
              </h3>
              <p className="text-lg text-gray-600 leading-relaxed">
                These core values aren't just words on a wall – they're the foundation of every interaction, 
                every decision, and every moment of care we provide. They guide us in creating environments 
                where seniors don't just live, but thrive with dignity and joy.
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CoreValues;